import script from "./BulkFiles.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkFiles.vue?vue&type=script&setup=true&lang=js"

import "./BulkFiles.vue?vue&type=style&index=0&id=516dde8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-516dde8c"]])

export default __exports__